import {useTranslationContext} from 'platform/components';
import {cn, cva} from 'platform/shared';

import {uniqBy} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {LightboxVideo} from '../types/LightboxVideo';
import {Select} from './Select';

interface SlideshowVideoProps extends RequiredTestIdProps {
  videoVariants: NonNullable<LightboxVideo['variants']>;
  isVisible: boolean;
  isActive?: boolean;
  value: string;
  onChange: (value: string) => void;
}

const videoQualityVariants = cva(
  'z-[var(--z-lightbox-actions)] transition-opacity duration-150 ease-out',
  {
    variants: {
      isVisible: {
        true: 'opacity-100',
        false: 'opacity-0',
      },
    },
  }
);

export function VideoQualitySelect(props: SlideshowVideoProps) {
  const t = useTranslationContext();

  const options = uniqBy((variant) => variant.type, props.videoVariants).map((variant) => {
    const label = variant.type === 'default' ? t('general.labels.default') : variant.type;
    const isSelected =
      props.value === variant.type || (variant.type === 'default' && isNilOrEmpty(props.value));

    return {
      label,
      value: variant.type,
      isSelected,
      onClick: () => {
        props.onChange(variant.type);
      },
    };
  });

  return (
    <div className={cn(videoQualityVariants({isVisible: props.isVisible}))}>
      <Select
        value={props.value}
        options={options}
        placeholder={t('general.labels.default')}
        tabIndex={props.isActive ? 0 : -1}
        data-testid={suffixTestId('videoQuality', props)}
      />
    </div>
  );
}
